//@ts-nocheck
import { useContext } from 'react';
import NavigationContext from './NavigationContext';

export default function useNavigation() : INavigationContext {

    const context : INavigationContext = useContext(NavigationContext);
    return context;
}